export default __webpack_public_path__ + "6d9e3f6729c4116a76d45b9e4259729f.png";